import { signalStore, withState, withMethods, patchState, withComputed } from '@ngrx/signals';
import { computed } from '@angular/core';
import { configModel, ms_Config } from 'src/models/config.model';

interface ConfigState {
  config: configModel | null;
  isLoading: boolean;
  error: string | null;
  isInitialized: boolean;
}

const initialState: ConfigState = {
  config: null,
  isLoading: false,
  error: null,
  isInitialized: false
};

export const ConfigStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed((store) => ({
    // Check if config data exists
    hasConfig: computed(() => store.config() !== null),
    
    // Check if store is ready (initialized and not loading)
    isReady: computed(() => store.isInitialized() && !store.isLoading()),
    
    // Get contact us URL from config
    contactUsUrl: computed(() => {
      const config = store.config();
      return config?.getConfigkeyname('Header_Contact') ?? '';
    }),
    
    // Check if there's an active error
    hasError: computed(() => store.error() !== null)
  })),
  withMethods((store) => ({
    // Set config data and mark as initialized
    setConfig(config: configModel) {
      patchState(store, { 
        config, 
        isInitialized: true,
        error: null 
      });
    },
    
    // Update loading state
    setLoading(loading: boolean) {
      patchState(store, { isLoading: loading });
    },
    
    // Set error message
    setError(error: string | null) {
      patchState(store, { 
        error,
        isLoading: false 
      });
    },
    
    // Get specific config item by key
    getConfigByKey(key: string): ms_Config | null {
      const config = store.config();
      if (!config || !config.config) {
        return null;
      }
      
      const configItem = store.config()?.config.find(item => item.keyText === key);
      return configItem || null;
    },
    
    // Get config value by key (returns string)
    getConfigValue(key: string): string {
      const config = store.config();
      return config?.getConfigkeyname(key) ?? '';
    },
    
    // Reset store to initial state
    reset() {
      patchState(store, initialState);
    }
  }))
);
